export default __webpack_public_path__ + "b81f6ace8518733662b914066c2c4475.svg";